<template>
    <div tabindex="-1"
         role="dialog"
         :id="id"
         class="modal fade"
         data-parent="#app"
         ref="modal"
    >
        <div role="document" class="modal-dialog modal-lg">
            <div class="modal-content">
                <media-library v-if="isOpen"
                               :file-type="fileType"
                               :multi-select="isMultiSelect"
                               ref="mediaLibrary"
                               :is-prompt="true"
                               @close="close"
                               :trans="trans"
                               :warn-cache-driver="warnCacheDriver"
                ></media-library>
            </div>
        </div>
    </div>
</template>

<script>
    import {COMMANDS, EVENTS} from "./enums";

    export default {
        data() {
            return {
                id: 'media-library-prompt-modal',
                params: null,
                fileType: null,
                isMultiSelect: false,
                isOpen: false,
                $modal: null
            }
        },

        props: {
            trans: {
                type: Object,
                required: true
            },

            warnCacheDriver: {
                type: Boolean,
                default: false
            }
        },

        methods: {
            hide() {
                this.$modal.modal('hide');
            },

            open(params) {
                this.params = params;
                this.fileType = params.type;
                this.isMultiSelect = params.multi;
                this.isOpen = true;

                this.$modal.modal({
                    backdrop: 'static'
                });

                this.$nextTick(() => {
                    this.initialize();
                });
            },

            initialize() {
                if (this.isMultiSelect && this.params.files) {
                    this.$refs.mediaLibrary.selectFiles(this.params.files);
                } else if (!this.isMultiSelect) {
                    if (this.params.file) {
                        this.$store.dispatch('MediaLibrary/activateFile', this.params.file);
                    }
                    EventBus.$on(EVENTS.FILE_SELECTION_CONFIRMED, this.selectionConfirmed);
                }

                if (this.params.onSelect) {
                    EventBus.$on(EVENTS.FILE_SELECTED, this.params.onSelect);
                }

                if (this.params.onUnselect) {
                    EventBus.$on(EVENTS.FILE_UNSELECTED, this.params.onUnselect);
                }
            },

            selectionConfirmed(selection) {
                this.params.ok(selection);
                this.hide();
            },

            close() {
                this.hide();
            },

            onHidden() {
                EventBus.$off(EVENTS.FILE_SELECTION_CONFIRMED, this.selectionConfirmed);
                EventBus.$off(EVENTS.FILE_SELECTED, this.params.onSelect);
                EventBus.$off(EVENTS.FILE_UNSELECTED, this.params.onUnselect);
                this.isOpen = false;
            },

            // BUGFIX - Jura Severa
            // If is ck editor balloon open in another modal (modal-form for example) 
            // then there is an issue with z-index of the balloon element. So we need increase
            // zindex of actual modal to hide the ck-balloon-panel
            adjustZIndexRelativeToCkEditor() {
                const ckBallonPanelZIndex = $('.ck-balloon-panel').css('z-index');
                // Is ckeditor balloon present?
                if (ckBallonPanelZIndex) {
                    const modalZIndex = this.$modal.css('z-index');
                    // check if actual index is lesser then ck balloon
                    if (modalZIndex <= ckBallonPanelZIndex) {
                        this.$modal.css('z-index', modalZIndex + 1);
                    }
                }
            }
        },

        mounted() {
            this.$modal = $(this.$refs.modal);
            this.$modal.on('hidden.bs.modal', this.onHidden);
            this.$modal.on('shown.bs.modal', this.adjustZIndexRelativeToCkEditor);
            EventBus.$on(COMMANDS.OPEN_PROMPT, this.open);
        },

        destroyed() {
            EventBus.$off(COMMANDS.OPEN_PROMPT, this.open);
            this.$modal.off('shown.bs.modal', this.adjustZIndexRelativeToCkEditor)
        }
    }
</script>

<style scoped>
    @media (min-width: 1200px) {
        .modal-lg {
            width: 1100px;
        }
    }

    .modal-content {
        max-height: 90vh;
        overflow: auto;
    }
</style>
